/* =============================================
   LUARARTS THEME — Global JS
   ============================================= */

document.addEventListener('DOMContentLoaded', () => {

  // Reduce easy video downloading from the browser UI and block right-click menu.
  function protectVideos(scope = document) {
    scope.querySelectorAll('video').forEach((video) => {
      video.setAttribute('controlsList', 'nodownload noplaybackrate');
      video.setAttribute('disablePictureInPicture', '');
      video.addEventListener('contextmenu', (event) => event.preventDefault());
    });
  }

  protectVideos();


  // ---- Cart helpers: counter + "Open Cart" notice ----
  const cartCountSelector = '.la-cart-count, .la-floating-cart-count';

  async function updateCartCount() {
    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!res.ok) return;
      const cart = await res.json();
      document.querySelectorAll(cartCountSelector).forEach(el => {
        const floating = el.closest('.la-floating-cart');
        if (floating) floating.classList.toggle('has-items', (cart.item_count || 0) > 0);
        el.textContent = cart.item_count || 0;
        el.style.display = '';
      });
      return cart;
    } catch (e) {}
  }

  function showOpenCartNotice() {
    let notice = document.querySelector('.la-cart-notice');
    if (!notice) {
      notice = document.createElement('div');
      notice.className = 'la-cart-notice';
      notice.setAttribute('role', 'status');
      notice.setAttribute('aria-live', 'polite');
      notice.innerHTML = `
        <span class="la-cart-notice-text">Added to cart</span>
        <a class="la-cart-notice-link" href="/cart">Open Cart</a>
      `;
      document.body.appendChild(notice);
    }

    notice.classList.add('is-visible');
    clearTimeout(notice._hideTimer);
    notice._hideTimer = setTimeout(() => {
      notice.classList.remove('is-visible');
    }, 5000);
  }

  window.LuarArtsCart = {
    updateCount: updateCartCount,
    showOpenCartNotice
  };


  // ---- Add to Cart (AJAX) ----
  document.querySelectorAll('.la-add-btn[data-variant-id]').forEach(btn => {
    btn.addEventListener('click', async () => {
      const variantId = btn.dataset.variantId;
      const originalText = btn.textContent;

      btn.textContent = 'Adding...';
      btn.disabled = true;

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });

        if (res.ok) {
          btn.textContent = '✓ Added';
          btn.classList.add('added');
          await updateCartCount();
          showOpenCartNotice();
          setTimeout(() => {
            btn.textContent = originalText;
            btn.classList.remove('added');
            btn.disabled = false;
          }, 2500);
        }
      } catch (e) {
        btn.textContent = 'Error';
        btn.disabled = false;
      }
    });
  });


  // ---- Product page main Add to Cart (AJAX) ----
  const lpForm = document.querySelector('#lp-cart-form-disabled-by-product-js');
  if (lpForm) {
    lpForm.addEventListener('submit', async (event) => {
      event.preventDefault();
      const btn = lpForm.querySelector('.lp-add-btn');
      const formData = new FormData(lpForm);
      const originalText = btn ? btn.textContent : '';
      if (btn) { btn.textContent = 'Adding...'; btn.disabled = true; }
      try {
        const res = await fetch('/cart/add.js', { method: 'POST', body: formData, credentials: 'same-origin' });
        if (res.ok) {
          if (btn) {
            btn.textContent = '✓ Added';
            btn.classList.add('added');
          }
          await updateCartCount();
          showOpenCartNotice();
          setTimeout(() => {
            if (btn) {
              btn.textContent = originalText;
              btn.classList.remove('added');
              btn.disabled = false;
            }
          }, 1800);
        } else if (btn) {
          btn.textContent = 'Error';
          btn.disabled = false;
        }
      } catch (e) {
        if (btn) {
          btn.textContent = 'Error';
          btn.disabled = false;
        }
      }
    });
  }

  updateCartCount();

  // ---- Collection Filter Pills ----
  document.querySelectorAll('.la-pill[data-tag]').forEach(pill => {
    pill.addEventListener('click', () => {
      const tag = pill.dataset.tag;
      const url = tag === 'all'
        ? window.location.pathname
        : window.location.pathname + '/' + tag;
      window.location.href = url;
    });
  });

  // ---- Sort Select ----
  const sortSelect = document.querySelector('.la-sort');
  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      const url = new URL(window.location);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  // ---- Mobile Nav Toggle ----
  const hamburger = document.querySelector('.la-hamburger');
  const navLinks = document.querySelector('.la-nav-links');
  if (hamburger && navLinks) {
    hamburger.addEventListener('click', () => {
      const open = navLinks.classList.toggle('mobile-open');
      hamburger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

});


// ---- Wishlist / Favorites ----
(() => {
  const KEY = 'luararts_wishlist_v1';
  const getItems = () => {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch(e) { return []; }
  };
  const setItems = (items) => localStorage.setItem(KEY, JSON.stringify(items));
  const find = (items, handle) => items.find((item) => item.handle === handle);

  function syncButtons() {
    const items = getItems();
    document.querySelectorAll('[data-wishlist-nav]').forEach((nav) => {
      nav.hidden = false;
      nav.classList.toggle('has-items', items.length > 0);
    });
    document.querySelectorAll('[data-wishlist-toggle]').forEach((btn) => {
      const active = !!find(items, btn.dataset.handle);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-label', active ? 'Remove from favorites' : 'Add to favorites');
    });
  }

  function renderWishlist(targetSelector, emptySelector) {
    const target = document.querySelector(targetSelector);
    if (!target) return;
    const items = getItems();
    const empty = emptySelector ? document.querySelector(emptySelector) : null;
    if (!items.length) {
      target.innerHTML = '';
      if (empty) empty.style.display = '';
      return;
    }
    if (empty) empty.style.display = 'none';
    target.innerHTML = items.map((item) => `
      <a class="la-wishlist-item" href="${item.url}">
        ${item.image ? `<img src="${item.image}" alt="${item.title.replace(/"/g, '&quot;')}" loading="lazy">` : '<div></div>'}
        <div><strong>${item.title}</strong><span>${item.price || ''}</span></div>
        <span>View</span>
      </a>
    `).join('');
  }

  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();

    const items = getItems();
    const handle = btn.dataset.handle;
    const existing = find(items, handle);
    if (existing) {
      setItems(items.filter((item) => item.handle !== handle));
    } else {
      items.unshift({
        handle,
        title: btn.dataset.title || handle,
        url: btn.dataset.url || '#',
        image: btn.dataset.image || '',
        price: btn.dataset.price || ''
      });
      setItems(items.slice(0, 60));
    }
    syncButtons();
    renderWishlist('#la-wishlist-grid', '#la-wishlist-empty');
    renderWishlist('#la-account-wishlist');
    renderWishlist('#la-search-wishlist-grid', '#la-search-wishlist-empty');
    const searchWish = document.querySelector('#la-search-wishlist');
    if (searchWish && window.location.hash === '#favorites') searchWish.hidden = false;
  });

  
  window.addEventListener('hashchange', () => {
    const searchWish = document.querySelector('#la-search-wishlist');
    if (searchWish) {
      searchWish.hidden = window.location.hash !== '#favorites';
      renderWishlist('#la-search-wishlist-grid', '#la-search-wishlist-empty');
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    syncButtons();
    renderWishlist('#la-wishlist-grid', '#la-wishlist-empty');
    renderWishlist('#la-account-wishlist');
    renderWishlist('#la-search-wishlist-grid', '#la-search-wishlist-empty');
    const searchWish = document.querySelector('#la-search-wishlist');
    if (searchWish && window.location.hash === '#favorites') searchWish.hidden = false;
  });
})();

